import reducers from './reducers';

const dashboardReducers = {
  webStats: reducers.getWebStats,
};

export { dashboardReducers };
